import { PageHeader, Select, Space, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TagOutlined, PlusOutlined } from "@ant-design/icons";
import { ButtonItem, SelectItem, TableItemDinamico, dineroDisabledMask, TourItem } from "../../../Components/Items";
import moment from "moment";
import ModalEtiquetaActivoFijo from "./ModalEtiquetaActivoFijo/ModalEtiquetaActivoFijo";
import AgregarUnidadActivoFijo from "./AgregarUnidadActivoFijo/AgregarUnidadActivoFijo";

const { Option } = Select;

// Clonado del patron de Pages/Panel/Lotes/Lotes.js (listado general → listado
// por Activo especifico via history.push+location.state), pedido explicitamente
// por el usuario en vez del patron generico de Inventario/MovimientosInventario.
class InventarioActivos extends Component {
  tableRef = null;
  refTabla = React.createRef();
  refAgregarUnidad = React.createRef();
  state = {
    loading: false,
    objetoProyectos: [],
    todasProyectos: [],
    todasUnidades: [],
    proyecto: undefined,
    proyectoId: undefined,
    totalRecords: 0,
    openTour: false,
    modalEtiqueta: false,
    modalEtiquetaId: null,
    modalEtiquetaFolio: null,
    modalAgregarUnidad: false,
  };

  abrirAgregarUnidad() {
    this.setState({ modalAgregarUnidad: true });
  }

  cerrarAgregarUnidad() {
    this.setState({ modalAgregarUnidad: false });
    if (this.tableRef) this.tableRef.updateExternalFilters({ proyectoId: this.state.proyectoId });
  }

  abrirEtiqueta(record) {
    this.setState({
      modalEtiqueta: true,
      modalEtiquetaId: record._id,
      modalEtiquetaFolio: record.serieNumero || record.numero,
    });
  }

  cerrarEtiqueta() {
    this.setState({ modalEtiqueta: false, modalEtiquetaId: null, modalEtiquetaFolio: null });
  }

  async consultarUnidades(params) {
    this.setState({ loading: true });

    const payload = {
      empresaId: this.props.empresaId,
      ...params,
      limit: params.pageSize,
    };

    if (this.state.proyectoId) {
      payload.proyectoId = this.state.proyectoId;
    }

    await axios
      .post("activosFijos/selectTodasUnidadesActivoFijo", payload, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            todasUnidades: res.data.data || [],
            totalRecords: res.data.totalRecords || 0,
          });
        } else {
          this.setState({ todasUnidades: [], totalRecords: 0 });
        }
      })
      .catch(() => {
        this.setState({ todasUnidades: [] });
      });
    this.setState({ loading: false });
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post("proyectos/selectProyectos", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasProyectos: res.data,
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>{value.nombre}</Option>
            )),
          });
        }
      });
    this.setState({ loading: false });
  }

  onChangeProyecto(value) {
    if (value === 0) {
      this.setState({ proyecto: undefined, proyectoId: undefined }, () => {
        if (this.tableRef) this.tableRef.updateExternalFilters({ proyectoId: undefined });
      });
    } else {
      const proyecto = this.state.todasProyectos.find((valueState) => valueState._id.toString() === value.toString());
      this.setState({ proyecto: proyecto.nombre, proyectoId: proyecto._id }, () => {
        if (this.tableRef) this.tableRef.updateExternalFilters({ proyectoId: proyecto._id });
      });
    }
  }

  render() {
    const columns = [
      {
        title: "Serie / Folio",
        dataIndex: "serieNumero",
        key: "serieNumero",
        width: "10%",
      },
      {
        title: "Activo",
        dataIndex: "insumo",
        key: "insumo",
        width: "22%",
        render: (value) => value?.descripcion || "-",
      },
      {
        title: "Tipo de Activo",
        dataIndex: "tipoDeActivo",
        key: "tipoDeActivo",
        width: "15%",
        render: (value) => value?.nombre || "-",
      },
      {
        title: "Ubicación",
        dataIndex: "ubicacionFisica",
        key: "ubicacionFisica",
        width: "12%",
      },
      {
        title: "Fecha Adquisición",
        dataIndex: "fechaAdquisicion",
        key: "fechaAdquisicion",
        render: (value) => (value ? moment(value).format("DD/MM/YYYY") : "-"),
        width: "10%",
      },
      {
        title: "Costo",
        dataIndex: "costo",
        key: "costo",
        render: (value) => dineroDisabledMask(value),
        width: "10%",
      },
      {
        title: "Depreciación Acumulada",
        dataIndex: "depreciacionAcumulada",
        key: "depreciacionAcumulada",
        render: (value) => dineroDisabledMask(value),
        width: "10%",
      },
      {
        title: "Valor en Libros",
        dataIndex: "valorEnLibros",
        key: "valorEnLibros",
        render: (value) => dineroDisabledMask(value),
        width: "10%",
      },
      {
        title: "Acción",
        key: "accion",
        align: "center",
        render: (record, _row, index) => (
          <Tooltip title="Imprimir etiqueta" placement="top">
            <ButtonItem
              type="default"
              size="small"
              morado
              icon={<TagOutlined />}
              key={index.toString()}
              onClick={(e) => {
                e.stopPropagation();
                this.abrirEtiqueta(record);
              }}
            />
          </Tooltip>
        ),
        width: "8%",
      },
    ];

    return (
      <>
        <PageHeader
          title={this.state.proyecto ? "Inventario de Activos: " + this.state.proyecto : "Inventario de Activos: Todos"}
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={
            <Space style={{ width: "100%" }}>
              <SelectItem placeholder="Proyecto" width={200} onChange={this.onChangeProyecto.bind(this)} defaultValue={0}>
                <Option value={0}>Todos</Option>
                {this.state.objetoProyectos}
              </SelectItem>
              {this.props.permisoAgregarUnidadActivoFijo && (
                <span ref={this.refAgregarUnidad}>
                  <ButtonItem type="primary" icon={<PlusOutlined />} onClick={this.abrirAgregarUnidad.bind(this)}>
                    Agregar Unidad
                  </ButtonItem>
                </span>
              )}
              <ButtonItem type="default" blanco onClick={() => this.setState({ openTour: true })}>
                ¿Cómo funciona?
              </ButtonItem>
            </Space>
          }
        />
        <div ref={this.refTabla}>
          <TableItemDinamico
            ref={(ref) => (this.tableRef = ref)}
            onRef={(ref) => (this.tableRef = ref)}
            onFetchData={this.consultarUnidades.bind(this)}
            totalRecords={this.state.totalRecords}
            dataSource={this.state.todasUnidades || []}
            loading={this.state.loading}
            columns={columns}
            size="small"
            pagination={false}
            setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })}
            valorTextoDefault={""}
            filterStorageKey={"inventarioActivosFiltrosTabla" + this.props.empresaId}
            onRow={(record) => ({
              onDoubleClick: () => {
                this.props.history.push("/panel/unidadesActivoFijo", {
                  id: record.insumoId || record.insumo?._id,
                  proyectoId: this.state.proyectoId,
                });
              },
            })}
          />
        </div>
        <ModalEtiquetaActivoFijo
          visible={this.state.modalEtiqueta}
          entradaSalidaId={this.state.modalEtiquetaId}
          folio={this.state.modalEtiquetaFolio}
          onCancel={this.cerrarEtiqueta.bind(this)}
        />
        <AgregarUnidadActivoFijo
          visible={this.state.modalAgregarUnidad}
          proyectoId={this.state.proyectoId}
          cerrarAgregarUnidadActivoFijo={this.cerrarAgregarUnidad.bind(this)}
        />
        <TourItem
          open={this.state.openTour}
          onClose={() => this.setState({ openTour: false })}
          steps={[
            {
              title: "Inventario de Activos",
              description: "Aquí ves TODAS las unidades físicas vigentes de todos tus Activos (ej. cada laptop concreta, con su serie, costo, depreciación acumulada y valor en libros).",
              target: null,
            },
            {
              title: "Agregar Unidad",
              description: "Da de alta una nueva unidad física sin salir de este listado — solo elige a qué Activo pertenece. Si prefieres partir directamente desde un Activo, entra a su detalle (ver siguiente paso).",
              target: () => this.refAgregarUnidad.current,
            },
            {
              title: "Ver detalle de un Activo",
              description: "Doble clic en una fila para ver todas las unidades de ESE Activo en particular (incluyendo vendidas y dadas de baja), y para dar de alta nuevas unidades, venderlas o darlas de baja.",
              target: () => this.refTabla.current,
            },
          ]}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarUnidadActivoFijo: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a69540249a8383de2bd7878")?.activado,
  };
};

export default connect(mapStateToProps)(InventarioActivos);
